import HexaLink from "./HexaLink";
/*import "./Hexagon.scss";*/
import { useCallback } from "react";

const Hexagon = ({
  idx,
  to,
  title,
  className = undefined,
  onMouse,
}: HexagonProps) => {
  const classes = ["Hexagon", className].join(" ");

  const onOver = useCallback(() => {
    onMouse(idx);
  }, [idx, onMouse]);

  const onOut = useCallback(() => {
    onMouse(0);
  }, [onMouse]);

  return (
    <HexaLink to={to} className={classes} onOver={onOver} onOut={onOut}>
      <div className="hexa-border">
        <div className="hexa-bg">
          <div className="hexa-shadow">
            <div className="hexa-selector">
              <h3 dangerouslySetInnerHTML={{ __html: title }} />
            </div>
          </div>
        </div>
      </div>
    </HexaLink>
  );
};

interface HexagonProps {
  idx: number;
  to: string;
  className?: string;
  title: string;
  onMouse: (e: any) => void;
}

export default Hexagon;
